export default {
  data() {
    return {
      isInitialFinished: false,
      hasOtherItemsChanged: false,
      oldData: null
    };
  },
  methods: {
    beforeDrawClose(done) {
      this.$refs.form.getFormChangedStatus((isChanged, changedFields) => {
        done(isChanged || this.hasOtherItemsChanged);
      });
    },
    beforeDrawCloseNotWithForm(done) {
      done(this.hasOtherItemsChanged);
    },
    closeDrawWithNoConfirm(done) {
      done();
    },
    setInitialFinished() {
      this.$nextTick(() => {
        this.isInitialFinished = true;
      });
    },
    setItemsNotInFormChangedStatus() {
      this.hasOtherItemsChanged = true;
    },
    resetInitialStatus() {
      this.isInitialFinished = false;
      this.hasOtherItemsChanged = false;
    },
    resetFormValidate() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    saveOldData(data) {
      this.oldData = JSON.stringify(data);
    },
    isDataChanged(newData) {
      this.hasOtherItemsChanged = this.oldData !== JSON.stringify(newData);
      return this.hasOtherItemsChanged;
    }
  }
};
